import Button from "components/button/Button";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import { getUserInfo } from "utils";
import "./styles.scss";

const Document = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const userInfo = getUserInfo();

  const handleExport = async () => {
    if (userInfo?.clinic_url_pdf) {
      window.location.href = userInfo?.clinic_url_pdf;
    }
    return false;
  };

  return (
    <div className="document-container">
      <div className="screen-title">{t("clinicCodeFirst.title")}</div>
      <div className="document-content">
        <div className="document-title">{userInfo?.clinic_name + t("clinicCodeFirst.clinicCode")}</div>
        <div className="document-value">{userInfo?.clinic_code}</div>
        <div className="document-title mt-50">{t("clinicCodeFirst.docs")}</div>
        <div className="document-link-row">
          <img src="/icons/document.webp" className="document-icon" />
          <div
            className="document-text"
            onClick={() => {
              handleExport();
            }}
          >
            {t("clinicCodeFirst.docsPdf")}
          </div>
        </div>
        <div className="document-notice">{t("clinicCodeFirst.docsDes")}</div>
        <Button
          text={t("clinicCodeFirst.buttonSubmit")}
          className="document-button"
          onClick={() => {
            history.push(ROUTE.CLINIC.PATIENT);
          }}
        />
      </div>
    </div>
  );
};
export default Document;
